import { FieldTypes } from "./field.types";
import { BaseModel } from "./base.model";
import { MetaDataStore } from "./datastore";

export function ReportWrapper(jsonData, id = jsonData["Root"]) {
  let kind = jsonData[id].Kind;
  let dynamicClass = ReportBaseModel.getMetadata(kind);
  let ds = new MetaDataStore(jsonData);
  let modelIns = new dynamicClass(ds, id, dynamicClass);
  ds.cache.set(id, modelIns);
  return modelIns;
}

class ReportBaseModel extends BaseModel {
  static classes = {}; //all metadata class against its name mapping

  static setFieldTypes(fields) {
    this.fieldTypes = Object.assign(fields, ReportBaseModel.fieldTypes);
    //creating a map for className and class
    ReportBaseModel.classes[this.name] = this;
  }

  static getMetadata(kind) {
    if (ReportBaseModel.classes[kind]) {
      return ReportBaseModel.classes[kind];
    }
    throw new Error(`Metadata definition for '${kind}' is not found`);
  }

  updateSavedAt(lastSavedAt) {
    this.dataSet._last_saved_at = lastSavedAt;
  }
}

class Report extends ReportBaseModel {
  static oneToManyList = [
    "Report::ReportField",
    "Report::Row",
    "Report::Column",
    "Report::Value",
    "Report::Sort",
    "Report::Filter",
    "Report::FilterParam"
  ];
}

Report.setFieldTypes({
  Name: FieldTypes.string.isRequired,
  Description: FieldTypes.string,
  ModelId: FieldTypes.string,
  ViewType: FieldTypes.string,
  TableCount: FieldTypes.number,
  StepCount: FieldTypes.number,
  FilterType: FieldTypes.string,
  Appearance: FieldTypes.object({
    ColorPalette: FieldTypes.array,
    Labels: FieldTypes.object({
      DataLabel: FieldTypes.boolean,
      Legend: FieldTypes.boolean,
      XAxisLabel: FieldTypes.boolean,
      YAxisLabel: FieldTypes.boolean
    }),
    ScaleType: FieldTypes.string,
    HeatMap: FieldTypes.string,
    Total: FieldTypes.object({
      ColumnSubtotal: FieldTypes.boolean,
      ColumnTotal: FieldTypes.boolean,
      GrandTotal: FieldTypes.boolean,
      RowSubtotal: FieldTypes.boolean,
      RowTotal: FieldTypes.boolean
    }),
    ValueCalculation: FieldTypes.string
  })
});

class ReportField extends ReportBaseModel {
  static oneToManyList = [
    "ReportField::Column",
    "ReportField::Row",
    "ReportField::Value",
    "ReportField::Sort",
    "ReportField::ReportField"
  ];

  static manyToOneList = ["Report::Report", "ReportField::ReportField"];
}
ReportField.setFieldTypes({
  Report: FieldTypes.kindOf("Report"),
  ReportField: FieldTypes.kindOf("ReportField"),
  FieldId: FieldTypes.string,
  ModelId: FieldTypes.string,
  ProjectFunction: FieldTypes.string,
  AggregateFunction: FieldTypes.string,
  FieldAttribute: FieldTypes.string
});

class Row extends ReportBaseModel {
  static oneToManyList = [];
  static manyToOneList = ["Report::Report", "ReportField::ReportField"];
}
Row.setFieldTypes({
  Report: FieldTypes.kindOf("Report").isRequired,
  ReportField: FieldTypes.kindOf("ReportField").isRequired,
  IsAggregate: FieldTypes.boolean,
  IsDesc: FieldTypes.boolean
});

class Column extends ReportBaseModel {
  static oneToManyList = ["Column::Column"];

  static manyToOneList = [
    "Report::Report",
    "Column::Column",
    "ReportField::ReportField"
  ];
}
Column.setFieldTypes({
  Report: FieldTypes.kindOf("Report"),
  Column: FieldTypes.kindOf("Column"),
  ReportField: FieldTypes.kindOf("ReportField").isRequired,
  IsAggregate: FieldTypes.boolean,
  IsDesc: FieldTypes.boolean,
  Width: FieldTypes.number
});

class Value extends ReportBaseModel {
  static manyToOneList = ["Report::Report", "ReportField::ReportField"];
}
Value.setFieldTypes({
  Report: FieldTypes.kindOf("Report").isRequired,
  ReportField: FieldTypes.kindOf("ReportField").isRequired,
  IsAggregate: FieldTypes.boolean,
  IsDesc: FieldTypes.boolean
});

class Sort extends ReportBaseModel {
  static manyToOneList = ["Report::Report", "ReportField::ReportField"];
}
Sort.setFieldTypes({
  Name: FieldTypes.string,
  FieldId: FieldTypes.string,
  Report: FieldTypes.kindOf("Report"),
  ReportField: FieldTypes.kindOf("ReportField").isRequired,
  IsDesc: FieldTypes.boolean
});

class Filter extends ReportBaseModel {
  static oneToManyList = [
    "Filter::Filter"
    // "Criteria::Condition"
  ];

  static manyToOneList = [
    "RHSParam::Filter",
    "Filter::Filter",
    "Report::Report"
  ];

  isCriteria() {
    return this.getValue("Type") === "Criteria";
  }
}

Filter.setFieldTypes({
  Report: FieldTypes.kindOf("Report"),
  Filter: FieldTypes.kindOf("Filter"),
  IsOR: FieldTypes.boolean,
  Type: FieldTypes.string,
  LHSValue: FieldTypes.string,
  LHSField: FieldTypes.kindOf("ReportField"),
  Operator: FieldTypes.string,
  RHSType: FieldTypes.string,
  RHSField: FieldTypes.kindOf("ReportField"),
  RHSValue: FieldTypes.any,
  RHSParam: FieldTypes.kindOf("FilterParam")
});

class FilterParam extends ReportBaseModel {
  static manyToOneList = ["Report::Report"];
}

FilterParam.setFieldTypes({
  Filter: FieldTypes.kindOf("Filter"),
  Report: FieldTypes.kindOf("Report"),
  Name: FieldTypes.string
});
